import { ChallengesReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: ChallengesReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
  leakFixSignup: undefined,
  smartMeterSignup: undefined,
  offers: {
    status: {
      loading: false,
      error: false,
      done: false,
    },
    data: null,
  },
};

const usageReducer = createReducer(initialState, {
  GET_CHALLENGES_CATEGORY_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_CHALLENGES_CATEGORY_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  GET_CHALLENGES_CATEGORY_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data.errors[0];
  },
  GET_OFFERS_PENDING: (state) => {
    state.offers.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_OFFERS_FULFILLED: (state, action) => {
    state.offers.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.offers.data = action.payload.data;
  },

  GET_OFFERS_REJECTED: (state, action) => {
    state.offers.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.offers.data = action.payload.data.errors[0];
  },
  LEAK_FIX_SIGNUP: (state) => {
    state.leakFixSignup = true;
  },
});

export default usageReducer;
